export default `
    <header id="LoginBanner" class="container #=data.bsc||""#">
        <div class="row banner">
            <div class="col col-xs-9 no-pad">
                <div class="sp-login-header-logo">
                </div>
            </div>
        </div>
    </header>
`;
